<template>
	<div class="w-full h-full flex items-center justify-center">
		<GridLayout
			:sidebar-state="false"
			:show-back-button="false"
			:show-prefered-route-checkbox="false"
		>
			<template #right-content>
				<MainContent
					class="w-full h-full flex justify-center items-center"
				>
					<span class="text-4xl">{{
						isInformation
							? 'INFORMAÇÕES'
							: 'FLUXO DE ATENDIMENTO DA RECEPÇÃO'
					}}</span>
				</MainContent>
			</template>
			<template #right-footer>
				<div class="w-full h-full flex items-center">
					<div class="h-full flex gap-3">
						<button
							class="btn btn-danger btn-fixed-size"
							:disabled="is_finished"
							@click="CancelFlow()"
						>
							SUSPENDER
						</button>
					</div>
					<div class="flex-1 h-full flex justify-end">
						<button
							class="btn btn-success btn-fixed-size"
							:disabled="!is_finishable"
							@click="FinishFlow()"
						>
							CONCLUIR
						</button>
					</div>
				</div>
			</template>
		</GridLayout>
	</div>
</template>

<script>
	const ROUTE_NAME_BY_FLOW_TYPE = {
		EMERGENCY: 'UrgentAppointmentScheduling',
		ATTENDING: 'UrgentAppointmentScheduling',
		CONFIRMATION: 'ConfirmWizard',
		SCHEDULING: 'PreAppointmentScheduling',
		FIT: 'FitWizard',
		SCHEDULING_SEARCH: 'SchedulingsSearch',
		EXAM_RESULTS: 'ExamResult',
		INFORMATION: null,
	}

	import { useDeleteAlert, useError } from '@/composables'

	export default {
		name: 'ReceptionFlow',
		props: {},
		data() {
			return {
				flow_type: null,
				temp_attendance_id: null,
				patient_id: null,
				is_finishable: false,
				is_finished: false,
			}
		},
		computed: {
			isInformation() {
				return this.flow_type === 'INFORMATION'
			},
		},
		methods: {
			RedirectByFlowType() {
				return this.RedirectToInternalRoute(this.flow_type)
			},
			RedirectToInternalRoute(flowKey) {
				const routeName = ROUTE_NAME_BY_FLOW_TYPE[flowKey]

				if (!routeName) return null

				return this.$router.push({
					name: routeName,
					query: {
						reception_flow_data: JSON.stringify({
							flow_type: this.flow_type,
							patient_id: this.patient_id,
							temp_attendance_id: this.temp_attendance_id,
						}),
					},
				})
			},
			async CancelFlow() {
				this.SendToParent(
					{
						type: 'RECEPTION_FLOW_CANCELLED',
						payload: {
							flow_type: this.flow_type,
							patient_id: this.patient_id,
							temp_attendance_id: this.temp_attendance_id,
						},
					},
					'*'
				)
				window.close()
			},
			FinishFlow() {
				this.is_finished = true

				this.SendToParent(
					{
						type: 'RECEPTION_FLOW_FINISHED',
						payload: {
							flow_type: this.flow_type,
							patient_id: this.patient_id,
							temp_attendance_id: this.temp_attendance_id,
						},
					},
					'*'
				)
				window.close()
			},
			SendToParent(message) {
				const targetOrigin = window.location.origin

				window.opener?.postMessage(message, targetOrigin)
			},
		},
		beforeMount() {
			const { flow_type, patient_id, temp_attendance_id } =
				this.$route && this.$route.query ? this.$route.query : {}

			if (flow_type) this.flow_type = flow_type
			if (patient_id) this.patient_id = patient_id
			if (temp_attendance_id) this.temp_attendance_id = temp_attendance_id

			// try {
			// 	const newQuery = { ...this.$route.query }
			// 	delete newQuery.flow_type
			// 	delete newQuery.patient_id
			// 	delete newQuery.temp_attendance_id
			// 	this.$router
			// 		.replace({ path: this.$route.path, query: newQuery })
			// 		.catch(() => {})
			// } catch (e) {
			// 	// Ignore any errors that occur during query cleanup
			// }

			if (this.flow_type === 'INFORMATION') return

			const route = ROUTE_NAME_BY_FLOW_TYPE[this.flow_type]
			if (!route) {
				useError('FLUXO DE ATENDIMENTO DESCONHECIDO').then(() => {
					window.close()
				})
			}
		},
		mounted() {
			if (this.isInformation) {
				this.is_finishable = true
				return
			}

			if (
				!Object.prototype.hasOwnProperty.call(
					ROUTE_NAME_BY_FLOW_TYPE,
					this.flow_type
				)
			) {
				return
			}

			this.RedirectByFlowType()
		},
	}
</script>

<style lang="scss" scoped></style>
